import { msg } from '@gonfalon/messages/msg';

import styles from './MetricVersionTag.module.css';

type MetricVersionTagProps = {
  version?: number | null;
  /** Render a leading "•" separator, for use after other content in a metadata row. */
  withSeparator?: boolean;
};

/**
 * Renders a metric's version number (e.g. `v3`) as muted inline text. Renders
 * nothing when the version is absent (null/undefined), so callers can include
 * it unconditionally.
 */
export const MetricVersionTag = ({ version, withSeparator = false }: MetricVersionTagProps) => {
  if (version === undefined || version === null) {
    return null;
  }

  return (
    <span className={styles.version} title={msg('metrics.sourceTags.versionLabel', { version })}>
      {withSeparator && (
        <span className={styles.separator} aria-hidden="true">
          •
        </span>
      )}
      v{version}
    </span>
  );
};
